import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { categories } from 'Components/MenuMain/MenuMainContent';
import { fetchAllEvents } from 'Pages/EventsPage/Redux/thunks';
import { fetchBanners } from 'Store/Banners/thunks';
import { getLocale } from 'Store/User/selectors';
import { HelmetProvider } from 'react-helmet-async';
import App from 'Components/App/App';

import { LocaleProvider } from 'antd';
import sv from 'antd/lib/locale-provider/sv_SE';
import en from 'antd/lib/locale-provider/en_GB';
import 'moment/locale/en-gb';
import 'moment/locale/sv';

import { IntlProvider } from 'react-intl';
import { addLocaleData } from 'react-intl';
import locale_sv from 'react-intl/locale-data/sv';
import locale_en from 'react-intl/locale-data/en';
addLocaleData([ ...locale_sv, ...locale_en ]);

const intlMessages = {
  'sv-SE': require('../../translations/sv.json'),
  'en-GB': require('../../translations/en.json'),
};

const antMessages = {
  'sv-SE': sv,
  'en-GB': en,
};

interface IPropsInternal {
  locale: string;
  fetchAllEvents: () => void;
  fetchBanners: () => void;
}

class AppContainer extends React.PureComponent<IPropsInternal> {

  componentDidMount() {
    this.props.fetchAllEvents();
    this.props.fetchBanners();
  }

  render() {
    const { locale } = this.props;

    return (
      <HelmetProvider>
        <IntlProvider locale={ locale } messages={ intlMessages[locale] }>
          <LocaleProvider locale={ antMessages[locale] }>
            <App { ... { categories } } />
          </LocaleProvider>
        </IntlProvider>
      </HelmetProvider>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    locale: getLocale(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchAllEvents,
    fetchBanners,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(AppContainer);


// WEBPACK FOOTER //
// ./src/components/App/AppContainer.tsx